// extracted by mini-css-extract-plugin
module.exports = {"AutoOrderDescription":"autoOrderDescription_AutoOrderDescription__xMT_X","heading":"autoOrderDescription_heading__LaN0j","paragraph":"autoOrderDescription_paragraph__gXZlX"};